<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="divisiones">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 md10 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="red darken-4">
                        <v-toolbar-title>Divisiones&nbsp;&nbsp;</v-toolbar-title>
                        <v-text-field
                            :disabled="bEditDivision"
                            hide-details
                            single-line
                            v-model="searchText"
                        ></v-text-field>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn :disabled="bEditDivision" small icon @click="onSearch" v-on="on">
                                     <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="bEditDivision"
                                text
                                class="text-none"
                                @click="onNewDivision"
                            >Nueva</v-btn>
                            <v-btn
                                :disabled="(bEditDivision || divisionID === 0 )"
                                text
                                class="text-none"
                                @click="onEditDivision"
                            >Editar</v-btn>
                            <v-btn
                                :disabled="(bEditDivision || divisionID === 0 )"
                                text
                                class="text-none"
                                @click="onDeleteDivision"
                            >Borrar</v-btn>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="bEditDivision" @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item :disabled="bEditDivision" @click="onNewDivision">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-tag-plus</v-icon>&nbsp; Nueva División
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEditDivision" @click="onEditDivision">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-tag-text</v-icon>&nbsp; Editar División
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEditDivision" @click="onDeleteDivision">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-tag-off</v-icon>&nbsp; Borrar División
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="bEditDivision" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de divisiones y división seleccionada: -->
                    <v-container pa-2 grid-list-md>
                        <!-- Renglón único para lista de divisiones y card de división seleccionada: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de Planes: *************************** -->
                            <v-flex xs10 md4>
                                <v-card>
                                    <v-toolbar dense color="red darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title">Divisiones Registradas</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        :disabled="bEditDivision"
                                        color="grey lighten-4"
                                    >
                                        <v-list-item-group
                                            v-model="selectedDivisionIndex"
                                            color="orange accent-4"
                                            :mandatory="!bNew"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(division, i) in divisiones"
                                                :key="i"
                                                @click="selectDivision(division.divisionid)"
                                                :id="division.divisionid"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                    md2
                                                                    xs6
                                                                >{{ division.nombre }} - {{ division.sigla }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina lista de divisiones ********************************* -->

                            <!-- Info de división seleccionada: *********************** -->
                            <v-flex xs10 md8>
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="red lighten-2" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ selectedDivisionName }}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon> mdi-file-tree-outline</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout row>
                                                <v-flex xs9>
                                                    <v-text-field
                                                        dense
                                                        name="division"
                                                        label="División"
                                                        type="text"
                                                        outlined
                                                        v-model="nombreDivision"
                                                        :readonly="!bEditDivision"
                                                        color="red darken-1"
                                                        ref="division_field"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs3>
                                                    <v-text-field
                                                        dense
                                                        label="Sigla"
                                                        type="text"
                                                        outlined
                                                        v-model="sigla"
                                                        :readonly="!bEditDivision"
                                                        color="red darken-1"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs6>
                                                    <v-card>
                                                        <v-toolbar dense color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-title">Departamentos</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn small fab text :disabled="bEditDivision" @click="onAddDepartment" v-on="on">
                                                                        <v-icon>mdi-plus</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Nuevo Departamento</span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn small fab text :disabled="bEditDivision || departmentID === 0" @click="onEditDepartment" v-on="on">
                                                                        <v-icon>mdi-pencil</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Editar Departamento</span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn small fab text :disabled="bEditDivision || departmentID === 0" @click="onDeleteDepartment" v-on="on">
                                                                        <v-icon>mdi-delete</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Borrar Departamento</span>
                                                            </v-tooltip>
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            height="250"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                            
                                                        >
                                                            <v-list-item-group
                                                                v-model="selectedDepartmentIndex"
                                                                color="orange accent-4"
                                                                :mandatory="!bNew"
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(department, i) in departamentos"
                                                                    :key="i"
                                                                    @click="selectDepartment(department.departamentoid)"
                                                                    :id="department.departamentoid"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ department.nombre }}</v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs6>
                                                    <v-card>
                                                        <v-toolbar dense color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-title">Programas o Servicios</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn small fab text :disabled="bEditDivision || departmentID === 0" @click="onAddProgram" v-on="on">
                                                                        <v-icon>mdi-plus</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Nuevo Programa o Servicio</span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn small fab text :disabled="bEditDivision || programID === 0" @click="onEditProgram" v-on="on">
                                                                        <v-icon>mdi-pencil</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Editar Programa o Servicio</span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn small fab text :disabled="bEditDivision || programID === 0" @click="onDeleteProgram" v-on="on">
                                                                        <v-icon>mdi-delete</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Borrar Programa o Servicio</span>
                                                            </v-tooltip>
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            height="250"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                        >
                                                            <v-list-item-group
                                                                v-model="selectedProgramIndex"
                                                                color="orange accent-4"
                                                                :mandatory="!bNew"
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(program, i) in programas"
                                                                    :key="i"
                                                                    @click="selectProgram(program.programaid)"
                                                                    :id="program.programaid"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ program.nombre }}</v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout
                                                v-if="bEditDivision"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSaveDivision"
                                                        :disabled="!bEditDivision"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        :disabled="!bEditDivision"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de división seleccionada *********************** -->
                        </v-layout>

                        <!-- Modal para confirmar borrado de división: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingDivision" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar División</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-3">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar la división "{{ selectedDivisionName }}"?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteDivisionConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteDivision"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de división *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="red darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Búsqueda de Divisiones</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-3">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No hay divisiones registradas con ese nombre.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Información Incompleta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-4"
                                                    >mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                        <!-- Modal para editar o agregar departamento: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgEditDepartment"
                                persistent
                                max-width="35%"
                            >
                                <v-card class="grey lighten-2">
                                    <v-toolbar dense color="red darken-4" dark flat>
                                        <v-toolbar-title v-if="bNewDepartment" class="my-list-title"><v-icon>mdi-home-outline</v-icon> &nbsp; Nuevo departamento &nbsp;</v-toolbar-title>
                                        <v-toolbar-title v-else class="my-list-title"><v-icon>mdi-home-outline</v-icon> &nbsp; Editar departamento &nbsp;</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container grid-list-sm fluid>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        label="Nombre del departamento"
                                                        type="text"
                                                        v-model="departmentToEdit"
                                                        color="red darken-4"
                                                    ></v-text-field>
                                                </v-flex>                           
                                            </v-layout>
                                            <v-layout row justify-space-between>
                                                <v-flex xs6>
                                                    <v-text-field
                                                        dense
                                                        label="Sigla"
                                                        type="text"
                                                        v-model="departmentCodeToEdit"
                                                        color="red darken-4"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmDepartmentEdition"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelDepartmentEdition"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para agregar o editar un departamento ************************ -->

                        <!-- Modal para confirmar borrado de departamento: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingDepartment" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Departamento</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-3">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar al departamento "{{ selectedDepartmentName }}"?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteDepartmentConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteDepartment"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de departamento *************************** -->

                        <!-- Modal para editar o agregar programa: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgEditProgram"
                                persistent
                                max-width="35%"
                            >
                                <v-card class="grey lighten-2">
                                    <v-toolbar dense color="red darken-4" dark flat>
                                        <v-toolbar-title v-if="bNewProgram" class="my-list-title"><v-icon>mdi-book-outline</v-icon> &nbsp; Agregar programa &nbsp;</v-toolbar-title>
                                        <v-toolbar-title v-else class="my-list-title"><v-icon>mdi-book-outline</v-icon> &nbsp; Editar programa &nbsp;</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container grid-list-sm fluid>
                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        label="Nombre del programa"
                                                        type="text"
                                                        v-model="programToEdit"
                                                        color="red darken-4"
                                                    ></v-text-field>
                                                </v-flex>                           
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmProgramEdition"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelProgramEdition"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para agregar o editar un programa ************************ -->

                        <!-- Modal para confirmar borrado de programa: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingProgram" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Programa</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-3">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar al programa o servicio "{{ selectedProgramName }}"?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteProgramConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteProgram"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de programa *************************** -->

                        
                        <!-- Termina renglón único para lista de divisiones y división seleccionada -->
                    </v-container>
                    <!-- Termina container para lista de divisiones y división seleccionada -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'divisiones',
    data() {
        return {
            drawer: false,
            bEditDivision: false,
            originalDivision: null, //División antes de ser editada, en caso de que se cancele una edición.
            bNew: false,
            bInvalidData: false,
            errorMessage: '',

            divisionID: 0,
            departmentID: 0,
            programID: 0,
            nombreDivision: '',
            sigla: '',
            
		    menu: false,

            selectedDivisionName: '',
            bDeletingDivision: false,
            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.

            departamentos: [],
            selectedDepartmentIndex: -1,
            programas: [],
            selectedProgramIndex: -1,

            bDlgEditDepartment: false,
            bDlgEditProgram: false,
            bNewDepartment: false,
            bNewProgram: false,

            departmentToEdit: '',
            departmentCodeToEdit: '',
            programToEdit: '',

            bDeletingDepartment: false,
            bDeletingProgram: false,
            selectedDepartmentName: '',
            selectedProgramName: '',

        };
    },
    created() {
        this.selectFirstDivision();
    },
    
    methods: {
        onClose() {
            this.$router.push('/');
        },

        onNewDivision() {
            this.bEditDivision = true;
            this.bNew = true;
            this.selectedDivisionName = 'Nueva División';
            this.selectedDivisionIndex = -1;

            this.divisionID = 0;
            this.departmentID = 0;
            this.programID = 0;

            this.departamentos = [];
            this.programas = [];

            this.nombreDivision = '';
            this.sigla = '';
            
            this.$refs.division_field.focus();
        },
        onDeleteDivision() {
            this.bDeletingDivision = true;
        },
        cancelDeleteDivision() {
            this.bDeletingDivision = false;
        },
        deleteDivisionConfirmed() {
            this.bDeletingDivision = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            var i;
            for (i = 0; i < this.divisiones.length; i++)
            {
                if (this.divisiones[i].divisionid === this.divisionID)
                {
                    this.divisiones.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deleteDivision', this.divisionID);
            this.selectFirstDivision();
        },
        
        onEditDivision() {
            for(let i = 0; i < this.divisiones.length; i ++)
            {
                if (this.divisiones[i].divisionid === this.divisionID)
                {
                    this.originalDivision = JSON.parse(JSON.stringify(this.divisiones[i]));
                    break;
                }
            }
            this.bEditDivision = true;
        },
        
        onCancel() {
            if (this.bNew) {
                //Selecciona la primera división de la lista:
                this.selectFirstDivision();
                this.bNew = false;
            }
            else
            {
                //Vuelve a obtener los datos originales de la división seleccionada:

                //console.log("onCancel, originalDivision = ", this.originalDivision);

                for (let i = 0; i < this.divisiones.length; i ++)
                {
                    if (this.divisiones[i].divisionid === this.divisionID)
                    {
                        this.divisiones[i] = JSON.parse(JSON.stringify(this.originalDivision));
                        //console.log("división reestablecida a: ", this.divisiones[i]);
                        this.originalDivision = null;
                        this.selectDivision(this.divisionID);
                        break;
                    }
                }
                
            }
            this.bEditDivision = false;
        },

        onSaveDivision()
        {
            //var bDataOK = false;
            this.bInvalidData = false;

            //Se validan los datos:

            if (this.nombreDivision === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'El nombre de la división es obligatoria.';
            }
            else
            {
                //Checa si hay otra división con el mismo nombre:
                var i;
                for (i = 0; i < this.divisiones.length; i ++)
                {
                    //Si se está editando la división, se salta la división en edición (si es una división nueva divisionID = 0):
                    if (this.divisiones[i].divisionid === this.divisionID)
                    {
                        continue;
                    }
                    else
                    if (this.divisiones[i].nombre === this.nombreDivision)
                    {
                        this.bInvalidData = true;
                        this.errorMessage = "Ya existe otra división con el mismo nombre."
                        break;
                    }
                }
            }
            
            if (!this.bNew && !this.bInvalidData)
            {
                //Edición de división...

                const divisionInfo = {
                    divisionid: this.divisionID,
                    nombre: this.nombreDivision,
                    sigla: this.sigla,
                };
                //console.log('divisionInfo = ', divisionInfo);

                //Edición del registro en la BD:
                
                this.$store.dispatch('editDivision', divisionInfo);

                //Se actualiza el registro local:
                for (let i = 0; i < this.divisiones.length; i++)
                {
                    if (this.divisiones[i].divisionid === this.divisionID)
                    {
                        this.divisiones[i].nombre = this.nombreDivision;
                        this.divisiones[i].sigla = this.sigla;
                        
                        break;
                    }
                }
            } //end edición de división.
            else if (this.bNew && !this.bInvalidData)
            {
                //Registro de nueva división...

                this.bNew = false;

                const newDivision = {
                    divisionid: 0,
                    nombre: this.nombreDivision,
                    sigla: this.sigla,
                };

                this.$store.dispatch('saveNewDivision', newDivision);
            } //end registro de nueva división.

            if (!this.bInvalidData)
            {
                this.selectedDivisionName = this.nombreDivision;
                this.bEditDivision = false;
            }
        },

        selectFirstDivision()
        {
            //console.log("this.divisiones = ", this.divisiones);
            //console.log("selectedDivisionIndex = ", this.selectedDivisionIndex);
            if (this.divisiones.length > 0)
            {
                this.selectedDivisionIndex = 0;
                var divisionID = this.divisiones[this.selectedDivisionIndex].divisionid;
                this.selectDivision(divisionID);
            }
            else
            {
                this.selectedDivisionIndex = -1;
                this.divisionID = 0;
            }
        },

        selectDivision(divisionID)
        {
            this.divisionID = divisionID;

            for (let i = 0; i < this.divisiones.length; i++)
            {
                if (this.divisiones[i].divisionid === divisionID)
                {
                    this.nombreDivision = this.divisiones[i].nombre;
                    this.sigla = this.divisiones[i].sigla;
                    this.departamentos = this.divisiones[i].departamentos;
                    this.programas = [];
                    this.selectFirstDepartment();
                    
                    this.selectedDivisionName = this.nombreDivision;
                    this.scroll(this.divisiones[i].divisionid);
                    break;
                }
            }
        },

        selectFirstDepartment()
        {
            if (this.departamentos.length > 0)
            {
                this.selectedDepartmentIndex = 0;
                var departmentID = this.departamentos[this.selectedDepartmentIndex].departamentoid;
                this.selectDepartment(departmentID);
            }
            else
            {
                this.selectedDepartmentIndex = -1;
                this.departmentID = 0;
                this.programas = [];
                this.selectedProgramIndex = -1;
                this.programID = 0;
            }
        },

        selectDepartment(departmentID)
        {
            this.departmentID = departmentID;

            for (let i = 0; i < this.departamentos.length; i ++)
            {
                if (this.departamentos[i].departamentoid === departmentID)
                {
                    this.selectedDepartmentName = this.departamentos[i].nombre;
                    this.programas = this.departamentos[i].programas;
                    this.selectFirstProgram();
                    break;
                }
            }

            //console.log("departmentID = ", this.departmentID);
        },

        onAddDepartment(){
            this.departmentID = 0;
            this.bNewDepartment = true;
            this.bDlgEditDepartment = true;
        },

        onEditDepartment(){
            for (let i = 0; i < this.departamentos.length; i ++)
            {
                if (this.departamentos[i].departamentoid === this.departmentID)
                {
                    this.departmentToEdit = this.departamentos[i].nombre;
                    this.departmentCodeToEdit = this.departamentos[i].sigla;
                    this.bDlgEditDepartment = true;
                    break;
                }
            }
        },

        onConfirmDepartmentEdition(){

            this.bInvalidData = false;

            if (this.departmentToEdit === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "Teclee el nombre del departamento.";
            }
            else
            {
                //Checa si no hay otro departamento con el mismo nombre:
                for (let i = 0; i< this.departamentos.length; i ++)
                {
                    //Si se está editando el departamento, se salta el departamento en edición (si es un departamento nuevo departmentID = 0):
                    if (this.departamentos[i].departamentoid === this.departmentID)
                    {
                        continue;
                    }
                    else
                    if (this.departamentos[i].nombre === this.departmentToEdit)
                    {
                        this.bInvalidData = true;
                        this.errorMessage = "Ya existe otro departamento en la división con el mismo nombre."
                        break;
                    }
                }
            }

            if (!this.bNewDepartment && !this.bInvalidData)
            {
                //Edición de departamento:

                for (let i = 0; i < this.departamentos.length; i ++)
                {
                    if (this.departamentos[i].departamentoid === this.departmentID)
                    {
                        this.departamentos[i].nombre = this.departmentToEdit;
                        this.departamentos[i].sigla = this.departmentCodeToEdit;

                        const departmentToSave = {
                            divisionid: this.divisionID,
                            departamentoid: this.departamentos[i].departamentoid,
                            nombre: this.departamentos[i].nombre,
                            sigla: this.departamentos[i].sigla,
                            division: this.nombreDivision, //Para poder seleccionar después la misma división
                        };

                        this.$store.dispatch('editDepartment', departmentToSave);
                        
                        break;
                    }
                }
            }
            else
            if (this.bNewDepartment && !this.bInvalidData)
            {
                //Registro de nuevo departamento:
                //Obtiene un id temporal negativo basado en la longitud del arreglo:
                /*var tempID = 0;
                if (this.departamentos.length > 0)
                {
                    tempID = - (this.departamentos.length + 1);
                }
                else{
                    tempID = -1;
                }

                const newDepartment = {
                    departamentoid: tempID,
                    nombre: this.departmentToEdit,
                    sigla: this.departmentCodeToEdit,
                    programas: [],
                };

                this.departamentos.push(newDepartment);*/

                const newDepartment = {
                    divisionid: this.divisionID,
                    departamentoid: 0,
                    nombre: this.departmentToEdit,
                    sigla: this.departmentCodeToEdit,
                    division: this.nombreDivision, //Para poder seleccionar después la misma división
                };

                this.$store.dispatch('saveNewDepartment', newDepartment);
            }

            if (!this.bInvalidData)
            {
                this.bDlgEditDepartment = false;
                this.bNewDepartment = false;
                this.departmentToEdit = '';
                this.departmentCodeToEdit = '';
            }
        },

        onCancelDepartmentEdition(){
            this.bDlgEditDepartment = false;
            this.bNewDepartment = false;
            this.departmentToEdit = '';
            this.departmentCodeToEdit = '';
        },

        onDeleteDepartment(){
            this.bDeletingDepartment = true;
        },

        cancelDeleteDepartment(){
            this.bDeletingDepartment = false;
        },

        deleteDepartmentConfirmed() {
            this.bDeletingDepartment = false;

            const tempDepartmentID = this.departmentID; //Para no perder el departamento seleccionado en selectFirstDepartment() abajo.

            for(let i = 0; i < this.departamentos.length; i ++)
            {
                if (this.departamentos[i].departamentoid === this.departmentID)
                {
                    this.departamentos.splice(i, 1);
                    this.selectFirstDepartment();
                    break;
                }
            }

            //console.log("Borrar departamento ", tempDepartmentID)

            this.$store.dispatch('deleteDepartment', tempDepartmentID);
        },

        selectFirstProgram()
        {
            if (this.programas.length > 0 )
            {
                this.selectedProgramIndex = 0;
                var programID = this.programas[this.selectedProgramIndex].programaid;
                this.selectProgram(programID);
            }
            else
            {
                this.selectedProgramIndex = -1;
                this.programID = 0;
            }
        },

        selectProgram(programID)
        {
            this.programID = programID;
            
            for (let i = 0; i < this.programas.length; i ++)
            {
                if (this.programas[i].programaid === programID)
                {
                    this.selectedProgramName = this.programas[i].nombre;
                    //console.log("selectedProgramID = ", this.programID);
                    //console.log("selectedProgram ", this.programas[i].nombre);
                    break;
                }
            }
        },

        onAddProgram(){
            this.programID = 0;
            this.bNewProgram = true;
            this.bDlgEditProgram = true;
        },

        onEditProgram(){
            for (let i = 0; i < this.programas.length; i ++)
            {
                if (this.programas[i].programaid === this.programID)
                {
                    this.programToEdit = this.programas[i].nombre;
                    this.bDlgEditProgram = true;
                    break;
                }
            }
        },

        onConfirmProgramEdition(){
            this.bInvalidData = false;

            if (this.programToEdit === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "Teclee el nombre del programa.";
            }
            else
            {
                //Checa si no hay otro programa con el mismo nombre:
                for (let i = 0; i< this.programas.length; i ++)
                {
                    //Si se está editando el programa, se salta el programa en edición (si es un programa nuevo programID = 0):
                    if (this.programas[i].programaid === this.programID)
                    {
                        continue;
                    }
                    else
                    if (this.programas[i].nombre === this.programToEdit)
                    {
                        this.bInvalidData = true;
                        this.errorMessage = "Ya existe otro programa o servicio en el mismo departamento con el mismo nombre."
                        break;
                    }
                }
            }

            if (!this.bNewProgram && !this.bInvalidData)
            {
                //Edición de programa:

                for (let i = 0; i < this.programas.length; i ++)
                {
                    if (this.programas[i].programaid === this.programID)
                    {
                        this.programas[i].nombre = this.programToEdit;

                        const programToSave = {
                            departamentoid: this.departmentID,
                            programaid: this.programas[i].programaid,
                            nombre: this.programas[i].nombre,
                            division: this.nombreDivision, //Para poder seleccionar después la misma división
                        };

                        this.$store.dispatch('editProgram', programToSave);

                        break;
                    }
                }
            }
            else
            if (this.bNewProgram && !this.bInvalidData)
            {
                //Registro de nuevo programa:
                //Obtiene un id temporal negativo basado en la longitud del arreglo:
                /*var tempID = 0;
                if (this.programas.length > 0)
                {
                    tempID = - (this.programas.length + 1);
                }
                else{
                    tempID = -1;
                }

                const newProgram = {
                    programaid: tempID,
                    nombre: this.programToEdit,
                };

                this.programas.push(newProgram);*/

                const programToSave = {
                    departamentoid: this.departmentID,
                    programaid: 0,
                    nombre: this.programToEdit,
                    division: this.nombreDivision, //Para poder seleccionar después la misma división
                };

                this.$store.dispatch('saveNewProgram', programToSave);

            }

            if (!this.bInvalidData)
            {
                this.bDlgEditProgram = false;
                this.bNewProgram = false;
                this.programToEdit = '';
            }
        },

        onCancelProgramEdition(){
            this.bDlgEditProgram = false;
            this.bNewProgram = false;
            this.programToEdit = '';
        },

        onDeleteProgram(){
            this.bDeletingProgram = true;
        },

        cancelDeleteProgram(){
            this.bDeletingProgram = false;
        },

        deleteProgramConfirmed(){
            this.bDeletingProgram = false;

            const tempProgramID = this.programID; //Para no perder el programa seleccionado en selectFirstProgram() abajo.

            for (let i = 0; i < this.programas.length; i ++)
            {
                if (this.programas[i].programaid === this.programID)
                {
                    this.programas.splice(i, 1);
                    this.selectFirstProgram();
                    break;
                }
            }
            //console.log("ProgramaID a borrar: ", tempProgramID);

            this.$store.dispatch('deleteProgram', tempProgramID);
        },

        onSearch()
        {
            if (this.searchText != '')
            {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.divisiones.length; i++)
                {
                    var strLowerCaseText = this.divisiones[i].nombre.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0)
                    {
                        this.selectedDivisionIndex = i;
                        this.selectDivision(this.divisiones[i].divisionid);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound)
                {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },

        scroll(id)
        {
            //console.log("En scroll, id = ", id);
            if (document.getElementById(id) !== null)
            {
                document.getElementById(id).scrollIntoView({behavior: "smooth"});
            }
        }
    },
    computed:
    {
        ...mapGetters(['waitCursor', 'divisionFound']),
        selectedDivisionIndex:
        {
            get() {
                return this.$store.getters.selectedDivisionIndex;
            },
            set(selectedDivisionIndex) {
                this.$store.dispatch('updateSelectedDivisionIndex', selectedDivisionIndex);
            },
        },

        divisiones:
        {
            get() {
                return this.$store.getters.divisiones;
            },
            set(divisiones) {
                this.$store.dispatch('updateDivisiones', divisiones);
            },
        },

        // style="height: 578px; max-height:100%"
        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '700px';
            } else {
                height = '470px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '40';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '40';
            } else if (this.$vuetify.breakpoint.md) {
                height = '50';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '60';
            } else {
                height = '80';
            }
            return height;
        },
    },

    watch: 
    {
        divisionFound: function(value, oldValue){
            //console.log("divisionFound changed detected in Divisiones.vue, divisionFound = ", this.divisionFound);
            if (this.divisionFound)
            {
                //console.log("divisionFound changed, divisionFound = true");
                this.selectDivision(this.divisionID);
            }
        },
    }
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.divisiones {
    /* background: url('../assets/patiogallo2.jpg'); */
    background-color: white;
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>